/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Apply_Auto_FormatInputs */



/**
* | output |
* | --- |
* | "Apply auto format" |
*
* @param {Apply_Auto_FormatInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const apply_auto_format = /** @type {((inputs?: Apply_Auto_FormatInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Apply_Auto_FormatInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Appliquer l’auto-formatage")
	if (locale === "de") return /** @type {LocalizedString} */ ("Automatische Formatierung anwenden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Applica formattazione automatica")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Применить автоформатирование")
	if (locale === "es") return /** @type {LocalizedString} */ ("Aplicar formato automático")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("应用自动格式")
	if (locale === "ja") return /** @type {LocalizedString} */ ("自動フォーマットを適用する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑटो फॉर्मेट लागू करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Aplicar formatação automática")
	return /** @type {LocalizedString} */ ("Apply auto format")
});